import MyDocumentation from './MyDocumentation'

export default MyDocumentation
